{
  "completed": "Завършено: ",
  "current": "Текущ: ",
  "notCompleted": "Незавършено: ",
  "steplist": "Списък със стъпки"
}
